// extracted by mini-css-extract-plugin
export default {"root":"VhQnn_TitD","item":"KsB1ZPTPId"};